export const counties = [
  'Oakland',
  'Wayne',
  'Macomb',
  'Livingston',
  'Genesee',
  'Lapeer',
  'Washtenaw',
]

export const featuredCities = [
  'Howell',
  'Hartland',
  'Fowlerville',
  'Brighton',
  'New Hudson',
  'Novi',
  'Wixom',
  'Northville',
  'Walled Lake',
  'Farmington',
  'Farmington Hills',
  'West Bloomfield',
  'Commerce Township',
  'Livonia',
  'Dearborn',
]

export type CountyArea = {
  county: string
  cities: string[]
}

export const countyCities: CountyArea[] = [
  {
    county: 'Oakland County',
    cities: [
      'Auburn Hills',
      'Farmington',
      'Lakeville',
      'Oxford',
      'Walled Lake',
      'Berkley',
      'Ferndale',
      'Leonard',
      'Pleasant Ridge',
      'Waterford',
      'Birmingham',
      'Franklin',
      'Madison Heights',
      'Pontiac',
      'West Bloomfield',
      'Bloomfield Hills',
      'Hazel Park',
      'Milford',
      'Rochester',
      'White Lake',
      'Clarkston',
      'Highland',
      'New Hudson',
      'Royal Oak',
      'Wixom',
      'Clawson',
      'Holly',
      'Novi',
      'South Lyon',
      'Commerce Township',
      'Huntington Woods',
      'Oak Park',
      'Southfield',
      'Davisburg',
      'Keego Harbor',
      'Oakland',
      'Troy',
      'Drayton Plains',
      'Lake Orion',
      'Ortonville',
      'Union Lake',
    ],
  },
  {
    county: 'Wayne County',
    cities: [
      'Allen Park',
      'Flat Rock',
      'Inkster',
      'Redford',
      'Trenton',
      'Belleville',
      'Garden City',
      'Lincoln Park',
      'River Rouge',
      'Wayne',
      'Canton',
      'Grosse Ile',
      'Livonia',
      'Riverview',
      'Westland',
      'Dearborn',
      'Grosse Pointe',
      'Melvindale',
      'Rockwood',
      'Wyandotte',
      'Dearborn Heights',
      'Hamtramck',
      'New Boston',
      'Romulus',
      'Detroit',
      'Harper Woods',
      'Northville',
      'Southgate',
      'Ecorse',
      'Highland Park',
      'Plymouth',
      'Taylor',
    ],
  },
  {
    county: 'Macomb County',
    cities: [
      'Armada',
      'Fraser',
      'New Baltimore',
      'Romeo',
      'Utica',
      'Center Line',
      'Harrison Township',
      'New Haven',
      'Roseville',
      'Warren',
      'Clinton Township',
      'Macomb',
      'Ray',
      'Saint Clair Shores',
      'Washington',
      'Eastpointe',
      'Mount Clemens',
      'Richmond',
      'Sterling Heights',
    ],
  },
  {
    county: 'Livingston County',
    cities: [
      'Brighton',
      'Fowlerville',
      'Hamburg',
      'Howell',
      'Pinckney',
      'Cohoctah',
      'Gregory',
      'Hartland',
      'Lakeland',
    ],
  },
  {
    county: 'Genesee County',
    cities: [
      'Atlas',
      'Fenton',
      'Genesee',
      'Linden',
      'Swartz Creek',
      'Burton',
      'Flint',
      'Goodrich',
      'Montrose',
      'Clio',
      'Flushing',
      'Grand Blanc',
      'Mount Morris',
      'Davison',
      'Gaines',
      'Lennon',
      'Otisville',
    ],
  },
  {
    county: 'Lapeer County',
    cities: [
      'Almont',
      'Columbiaville',
      'Imlay City',
      'North Branch',
      'Attica',
      'Dryden',
      'Lapeer',
      'Otter Lake',
      'Clifford',
      'Hadley',
      'Metamora',
      'Silverwood',
    ],
  },
  {
    county: 'Washtenaw County',
    cities: [
      'Ann Arbor',
      'Dexter',
      'Saline',
      'Willis',
      'Bridgewater',
      'Manchester',
      'Whitmore Lake',
      'Ypsilanti',
      'Chelsea',
      'Salem',
      'Whittaker',
    ],
  },
]
